
// utils/constants.js

export const FREE_TRIAL_COUNT = 5;
export const FREE_LOGINED_COUNT = 8;
export const FREE_EDIT_IMAGE_COUNT = process.env.NEXT_PUBLIC_FREE_EDIT_IMAGE_COUNT ? parseInt(process.env.NEXT_PUBLIC_FREE_EDIT_IMAGE_COUNT, 10) : 2;
export const GLOBAL_DAILY_LIMIT = process.env.GLOBAL_DAILY_LIMIT ? parseInt(process.env.GLOBAL_DAILY_LIMIT, 10) : 100;
export const USER_DAILY_LIMIT = process.env.NEXT_PUBLIC_USER_DAILY_LIMIT ? parseInt(process.env.NEXT_PUBLIC_USER_DAILY_LIMIT, 10) : 5;
export const DAILY_VEO_FREE_COUNT = process.env.NEXT_PUBLIC_DAILY_VEO_FREE_COUNT ? parseInt(process.env.NEXT_PUBLIC_DAILY_VEO_FREE_COUNT, 10) : 10;

// Updated CATEGORIES array to match the structure used for the new mapping
export const CATEGORIES = [
  "prompt-image",
  "prompt-logo",
  "prompt-photo",
  "prompt-portrait",
  "prompt-landscape",
  "prompt-art",
  "prompt-painting",
  "prompt-illustration"
];

// Add this line:
export const CATEGORIE_NAMES = ["Image", "Logo", "Photo", "Portrait", "Landscape", "Art", "Painting", "Illustration"];

// New mapping from category short name to generatorType integer
export const CATEGORY_TO_GENERATOR_TYPE = {
  "image": 0,
  "logo": 1,
  "photo": 2,
  "portrait": 3,
  "landscape": 4,
  "art": 5,
  "painting": 6,
  "illustration": 7
};

export const PACKAGES = [
  {
    name: "Basic",
    price: 5,
    credits: 50,
    priceId: process.env.NEXT_PUBLIC_PRICE_ID_BASIC,
  },
  {
    name: "Popular",
    price: 10,
    credits: 110,
    priceId: process.env.NEXT_PUBLIC_PRICE_ID_POPULAR,
    popular: true,
  },
  {
    name: "Pro",
    price: 20,
    credits: 240,
    priceId: process.env.NEXT_PUBLIC_PRICE_ID_PRO,
  },
];
